import React from 'react';
import { whatWeOfferContent } from '@anonymizePro/mock/contents';
import OfferCard from '@anonymizePro/components/cards/offer-card';

function Index() {
    return (
        <div className="layoutMarginAndRound flex w-full flex-col items-center bg-white px-5 pb-[180px] pt-20 md:px-[80px] lg:px-[128px] lg:pb-[277px] lg:pt-[168px]">
            <p className="anonymize-h2 mb-14 text-black-800 lg:mb-[88px]">{whatWeOfferContent.title}</p>
            <div className="flex flex-wrap justify-center gap-2">
                {whatWeOfferContent.offers.map((offer) => {
                    return <OfferCard key={offer.title} offer={offer} />;
                })}
            </div>
        </div>
    );
}

export default Index;
